import axiosInstance from '../services/AxiosInstance';

export const getMerchantBalance = (getData) => {
  return axiosInstance.get("merchant-balance/list", {
    params: getData,
  });
};

export const getMBHUpdatedStatusSummaryAll = (params) => {
  return axiosInstance.get("merchant-balance/list-date", { params });
};


export const getMerchantWalletBalance = (id) => {
  return axiosInstance.get(`merchant-balance/show/${id}`);
};

export const addMerchantBalance = (data) => {
  return axiosInstance.post("merchant-balance/create", data);
};

export const getMerchantEscrowBalanceCount = (data) => {
  return axiosInstance.post("payout-api/check-balance", data);
};

export const getMerchantBalanceCount = (data) => {
  return axiosInstance.get("merchant-balance/overview", data);
};

export const updateMerchantBalance = (id, data) => {
  return axiosInstance.put(`merchant-balance/update/${id}`, data);
};

export const fetchMerchantBalanceById = async (id) => {
    const response = await axiosInstance.get(`merchant-balance/show/${id}`);
    return response.data;
};
